export default "__VITE_ASSET__Bw9R0YgS__"